const PageGroupType = Object.freeze({
    FAMILY: 'family',
    CUSTOMER: 'customer',
    PLATFORM: 'platform',
    ALL_CUSTOMERS: 'all_customers',
});
export default PageGroupType;

export const PageGroupUri = Object.freeze({
    PLATFORM: 'platforms',
    FAMILY: 'families',
    CUSTOMER: 'customers',
    ALL_CUSTOMERS: 'customerTotals',
});

export function getPageGroupTypeFromUri(uri) {
    return (
        Object.keys(PageGroupUri).find((key) => PageGroupUri[key] === uri) &&
        PageGroupType[Object.keys(PageGroupUri).find((key) => PageGroupUri[key] === uri)]
    );
}
